import type { DomainRecord, RedirectRecord, DomainItem, RedirectRule } from './types';

export function adaptDomainRecord(raw: unknown): DomainRecord {
  const data = (raw && typeof raw === 'object' ? raw : {}) as Partial<DomainRecord>;
  return {
    id: String(data.id || ''),
    tenant_id: String(data.tenant_id || ''),
    site_id: String(data.site_id || ''),
    hostname: String(data.hostname || ''),
    is_primary: Boolean(data.is_primary),
    txt_verification_token: String(data.txt_verification_token || ''),
    dns_verified_at: data.dns_verified_at ? String(data.dns_verified_at) : null,
    tls_status: String(data.tls_status || 'pending'),
    created_at: String(data.created_at || ''),
  };
}

export function adaptDomainRecordList(raw: unknown): DomainRecord[] {
  if (!Array.isArray(raw)) return [];
  return raw.map(adaptDomainRecord);
}

export function adaptRedirectRecord(raw: unknown): RedirectRecord {
  const data = (raw && typeof raw === 'object' ? raw : {}) as Partial<RedirectRecord>;
  return {
    id: String(data.id || ''),
    tenant_id: String(data.tenant_id || ''),
    site_id: String(data.site_id || ''),
    source_path: String(data.source_path || ''),
    target_url: String(data.target_url || ''),
    status_code: Number(data.status_code || 301),
    created_at: String(data.created_at || ''),
  };
}

export function adaptRedirectRecordList(raw: unknown): RedirectRecord[] {
  if (!Array.isArray(raw)) return [];
  return raw.map(adaptRedirectRecord);
}

export function adaptDomainItem(rec: DomainRecord): DomainItem {
  const status = (rec.tls_status || '').toLowerCase();
  const tlsStatus: 'ready' | 'error' | 'pending' =
    status === 'ready' || status === 'active' || status === 'verified'
      ? 'ready'
      : status === 'error' || status === 'failed'
      ? 'error'
      : 'pending';

  return {
    id: rec.id,
    hostname: rec.hostname,
    isPrimary: rec.is_primary,
    txtVerificationToken: rec.txt_verification_token,
    tlsStatus,
    dnsVerifiedAt: rec.dns_verified_at || null,
  };
}

export function adaptDomainItemList(raw: unknown): DomainItem[] {
  return adaptDomainRecordList(raw).map(adaptDomainItem);
}

export function adaptRedirectRule(rec: RedirectRecord): RedirectRule {
  return {
    id: rec.id,
    sourcePath: rec.source_path,
    targetUrl: rec.target_url,
    statusCode: rec.status_code,
  };
}

export function adaptRedirectRuleList(raw: unknown): RedirectRule[] {
  return adaptRedirectRecordList(raw).map(adaptRedirectRule);
}
